import { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { RootState } from 'shared/store/rootReducer';
import { toggleView } from 'shared/store/features/archiveFilterModalSlice';
import { ArchiveStatus } from '../filterOptions.enum';
import getStyles from '../modalsStyle.override';

const initialArchiveStatus = [
  {
    text: ArchiveStatus.active,
    checked: true
  },
  {
    text: ArchiveStatus.archived,
    checked: false
  }
];

const useArchiveFilterModalLogic = (
  archiveStatusButtonBoundingRect: ClientRect | null
) => {
  const dispatch = useDispatch();
  const { isArchiveFilterModalOpened } = useSelector(
    (state: RootState) => state.archiveFilterModal
  );
  const { archiveFilterStatus } = useSelector(
    (state: RootState) => state.archiveFilterStatus
  );
  const [
    archiveFilter,
    setArchiveFilter
  ] = useState<ArchiveStatus>(archiveFilterStatus);

  const onClose = () => dispatch(toggleView({ isArchiveFilterModalOpened: false }));

  const useStyles = useCallback(
    makeStyles(getStyles(archiveStatusButtonBoundingRect)),
    [archiveStatusButtonBoundingRect]
  );

  return {
    isArchiveFilterModalOpened,
    onClose,
    useStyles,
    archiveFilter,
    setArchiveFilter,
    initialArchiveStatus
  };
};

export default useArchiveFilterModalLogic;
